window.addEventListener('disable-pagination-links-submit', () => {
    disableButton();
})

function disableButton()
{
    const buttons = document.querySelectorAll('.links-container button');
    Array.from(buttons).forEach(el => el.addEventListener('click', e => e.preventDefault()))
}
